import TalentListPage from '../components/Talent/TalentListPage'

// Только те, кто в пресейле сейчас (current_only). Все, кто когда-либо был в
// пресейле, — на странице PresaleHistory (/presale/history)
const PreSales = () => {
  return (
    <>
      <title>PreSales | Talent Service</title>
      <TalentListPage
        talentType="presale"
        pageTitle="Presale"
        pageDescription="Talents who are in presale right now"
        defaultFilters={{ current_only: 'true' }}
      />
    </>
  )
}

export default PreSales
